const SettingOption = {
  ENABLED: 'enabled',
  DISABLED: 'disabled',
};

export { SettingOption };
